//----------------------------------------------------------------------------------------------------------------------

// Coords along the component's surface from its bottom-left (xy) and top-right (zw)
in vec4 v_component_coords;

//----------------------------------------------------------------------------------------------------------------------

// The width and height to wrap around, or -1.0 if wrapping should not occur
uniform vec2 u_wrap_dimensions;

// The texture to sample from directly
uniform sampler2D u_tex;

// The component coordinates of the texture (x_start, y_start, x_end, y_end)
uniform vec4 u_tex_rect;

// The clipping rect (for screenshot mode)
uniform vec4 u_clip_rect;

//----------------------------------------------------------------------------------------------------------------------

/**
 * A modulo function whose return value is always positive
 * @param n                 The number to mod
 * @param m                 The number to mod by
 * @return                  An always-positive modulo of n by m
 */
float euclidean_modulo(float n, float m) {
    return m <= 0.0 ? n : mod(mod(n, m) + m, m);
}

/**
 * Returns the color sampled from the texture
 * @param sampled_texture   The texture to sample
 * @param texture_rect      The rectangle this data covers, in surface coordinates (left, bottom, right, top)
 * @return                  The color pulled from this texture
 */
vec4 sample_texture(sampler2D sampled_texture, vec4 texture_rect) {
    // Take the (x, y) coordinates along the surface and convert them into UVs on the texture.
    vec2 coords = v_component_coords.xy - texture_rect.xy;
    coords.x = euclidean_modulo(coords.x, u_wrap_dimensions.x);
    coords.y = euclidean_modulo(coords.y, u_wrap_dimensions.y);
    vec2 uv = coords.xy / (texture_rect.zw - texture_rect.xy);

    return texture2D(sampled_texture, uv);
}

//----------------------------------------------------------------------------------------------------------------------

void main() {
    // Handle clipping for screenshot mode
    if (v_component_coords.x < u_clip_rect.x || v_component_coords.x < u_tex_rect.x) discard;
    if (v_component_coords.y < u_clip_rect.y || v_component_coords.y < u_tex_rect.y) discard;
    if (v_component_coords.x > u_clip_rect.z || v_component_coords.x > u_tex_rect.z) discard;
    if (v_component_coords.y > u_clip_rect.w || v_component_coords.y > u_tex_rect.w) discard;

    gl_FragColor = sample_texture(u_tex, u_tex_rect);
}
